import { RelativeUrl } from "@adora/shared/utils/environment";
import patch, { JsonValue } from "@adora/shared/utils/patch";
import { AdAsset } from "../../types/ad-asset";
import post from "@adora/shared/utils/post";
import Result from "@adora/shared/types/result";
import { BatchServerResponse } from "@adora/shared/types/batch";
import { filterEmptyValues } from "./helpers";
import { AdAssetGroup } from "../../types/ad-asset-group";
import { AdAssetGroupUpdateData } from "./types";

interface PublishAdAssetGroupData {
  brandId: number;
  adAssetGroupId: number;
}

export function publishMultiPlatform(data: PublishAdAssetGroupData) {
  const queryParams = {
    brand_id: data.brandId.toString(),
    ad_asset_group_id: data.adAssetGroupId.toString()
  };
  return post<BatchServerResponse[]>(`${RelativeUrl}/ad_asset_groups/publish/multi-platform`, queryParams);
}

export async function bulkUpdateAdAssets(
  adAssetGroupId: number,
  brandId: number,
  data: Partial<AdAsset>
): Promise<Result<AdAsset[]>> {
  const bodyParams: JsonValue = filterEmptyValues(data);

  return await patch<AdAsset[]>(`${RelativeUrl}/ad_assets/bulk/${adAssetGroupId}`, { brand_id: brandId }, bodyParams);
}

export async function updateAdAssetGroup(
  id: number,
  brandId: number,
  data: AdAssetGroupUpdateData
): Promise<Result<AdAssetGroup>> {
  const bodyParams: JsonValue = filterEmptyValues(data);
  return await patch<AdAssetGroup>(`${RelativeUrl}/ad_asset_groups/${id}`, { brand_id: brandId }, bodyParams);
}

export function retryPublish(brandId: number, adAssetGroupId: number) {
  return post<BatchServerResponse[]>(
    `${RelativeUrl}/ad_asset_groups/publish/retry?brand_id=${brandId}&ad_asset_group_id=${adAssetGroupId}`
  );
}

export function createOrUpdateAdAssetsFromAdBuilder(brandId: number, adAssetGroupId: number) {
  const bodyParams = {
    ad_asset_group_id: adAssetGroupId,
    brand_id: brandId
  };
  return post<BatchServerResponse[]>(`${RelativeUrl}/ad_builder_images/ad_assets`, {}, bodyParams);
}
